(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('newsletter-form')) {
    const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    class NewsletterForm extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.form = this.closest('form');
        this.trigger = this.querySelector('[data-newsletter-trigger]');
        this.submitButton = this.querySelector('[data-newsletter-submit]');
        this.formError = this.querySelector('[data-newsletter-form-error]');
        this.successMessage = this.querySelector('[data-newsletter-success]');
        this.fields = Array.from(this.querySelectorAll('[data-newsletter-field]'));
        this.busy = false;

        if (!this.form) return;
        this.form.noValidate = true;

        this.trigger.addEventListener('click', () => this.expand());
        this.form.addEventListener('input', (event) => this.onInput(event));
        this.form.addEventListener('focusout', (event) => this.onFocusOut(event));
        // Shopify's CAPTCHA script wraps form.submit() when it binds the form (on first
        // interaction): it adds the hCaptcha token, then calls the submit function it found.
        // Setting ours first makes it post in the background instead of reloading the page.
        this.form.submit = () => this.post();
        // The click fires before `submit` (also on Enter), so a disabled button can cancel it.
        this.submitButton.addEventListener('click', (event) => this.onSubmit(event));
        this.form.addEventListener('submit', (event) => this.onSubmit(event));

        this.updateSubmitState();

        // After a full-page post (browser without JS) the page reloads at the top,
        // where the fixed footer is hidden, so bring the result into view.
        if (this.dataset.state === 'success' || this.dataset.state === 'error') {
          this.scrollToFooter();
          if (this.dataset.state === 'success') this.successMessage.focus({ preventScroll: true });
        }
        if (this.dataset.state === 'success') this.dispatchSubscribed();
      }

      expand() {
        this.dataset.state = 'expanded';
        this.scrollToFooter();
        this.fields[0].focus({ preventScroll: true });
      }

      scrollToFooter() {
        if (!this.hasAttribute('data-reveal-footer')) return;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const scroll = () => {
          window.scrollTo({ top: document.documentElement.scrollHeight, behavior });
        };
        // The footer's min-height is synced by a ResizeObserver, so scroll again once it has grown.
        requestAnimationFrame(scroll);
        setTimeout(scroll, 350);
      }

      onInput(event) {
        const input = event.target;
        if (!this.fields.includes(input)) return;
        if (input.dataset.touched === 'true') this.validateField(input, true);
        this.updateSubmitState();
      }

      onFocusOut(event) {
        const input = event.target;
        if (!this.fields.includes(input)) return;
        input.dataset.touched = 'true';
        this.validateField(input, true);
      }

      getFieldError(input) {
        const value = input.value.trim();
        if (!value) return this.dataset.errorRequired;
        if (input.type === 'email' && !EMAIL_PATTERN.test(value)) return this.dataset.errorEmail;
        return '';
      }

      validateField(input, showError) {
        const message = this.getFieldError(input);
        if (showError) this.setFieldError(input, message);
        return !message;
      }

      setFieldError(input, message) {
        const error = this.querySelector(`[data-error-for="${input.id}"]`);
        if (!error) return;

        error.textContent = message;
        error.hidden = !message;
        if (message) {
          input.setAttribute('aria-invalid', 'true');
          input.setAttribute('aria-describedby', error.id);
        } else {
          input.removeAttribute('aria-invalid');
          input.removeAttribute('aria-describedby');
        }
      }

      isValid() {
        return this.fields.every((input) => !this.getFieldError(input));
      }

      updateSubmitState() {
        this.submitButton.setAttribute('aria-disabled', String(!this.isValid() || this.busy));
      }

      setBusy(busy) {
        this.busy = busy;
        if (busy) {
          this.form.setAttribute('aria-busy', 'true');
        } else {
          this.form.removeAttribute('aria-busy');
        }
        this.updateSubmitState();
      }

      onSubmit(event) {
        event.preventDefault();

        // Disabled or already sending: do nothing.
        if (this.busy || !this.isValid()) return;

        const captcha = window.Shopify && window.Shopify.captcha;
        if (!captcha || typeof captcha.protect !== 'function') {
          this.post();
          return;
        }

        this.setBusy(true);
        // Re-enable the button if hCaptcha never returns a token.
        this.captchaTimeout = setTimeout(() => this.setBusy(false), 20000);
        // protect() binds hCaptcha if needed; form.submit() then gets a token and calls post().
        captcha.protect(this.form, () => this.form.submit());
      }

      async post() {
        clearTimeout(this.captchaTimeout);
        if (this.posting || !this.isValid()) {
          if (!this.posting) this.setBusy(false);
          return;
        }

        this.posting = true;
        this.formError.textContent = '';
        this.setBusy(true);

        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            body: new URLSearchParams(new FormData(this.form)),
            headers: { Accept: 'text/html' },
          });
          const responseUrl = new URL(response.url);
          const html = await response.text();

          // Rejected (e.g. "Invalid CAPTCHA token"). Don't resend: hCaptcha tokens are single-use,
          // and the next click asks hCaptcha for a new one.
          if (!response.ok) {
            console.error('Newsletter sign-up rejected', response.status, html.slice(0, 200));
            this.formError.textContent = this.dataset.errorGeneric;
            return;
          }

          const remoteForm = new DOMParser().parseFromString(html, 'text/html').getElementById(this.form.id);
          const remoteState = remoteForm && remoteForm.querySelector('newsletter-form');
          const posted =
            responseUrl.searchParams.get('customer_posted') === 'true' ||
            (remoteState && remoteState.dataset.state === 'success');

          if (posted) {
            this.showSuccess();
            return;
          }

          const remoteError = remoteForm && remoteForm.querySelector('[data-newsletter-form-error]');
          this.formError.textContent = (remoteError && remoteError.textContent.trim()) || this.dataset.errorGeneric;
        } catch (error) {
          this.formError.textContent = this.dataset.errorGeneric;
        } finally {
          this.posting = false;
          this.setBusy(false);
        }
      }

      showSuccess() {
        this.dataset.state = 'success';
        this.successMessage.hidden = false;
        this.successMessage.focus({ preventScroll: true });
        this.dispatchSubscribed();
      }

      dispatchSubscribed() {
        this.dispatchEvent(new CustomEvent('newsletter:subscribed', { bubbles: true }));
      }
    }

    customElements.define('newsletter-form', NewsletterForm);
  }
  } catch(e) { console.error(e); }
})();

})();
